import React from "react";
import { X, RefreshCw } from "lucide-react";
import ProgressMeter from "../ProgressMeter";

const TONE_PRESETS = [
  { label: "Punchy & confident", value: "Punchy, confident, action-oriented. Short, declarative bullets. Quantify results aggressively." },
  { label: "Warm & collaborative", value: "Warm, collaborative, team-first. Emphasize partnership, mentorship, and cross-functional impact." },
  { label: "Technical & precise", value: "Technical, precise, data-driven. Lean on specifics, frameworks, metrics, and outcomes." },
  { label: "Executive & strategic", value: "Executive, strategic, vision-led. Frame work in terms of business outcomes, scale, and leadership." },
  { label: "Creative & bold", value: "Creative, bold, narrative-driven. Allow personality and storytelling to shine through." },
];

export default function RetailorModal({
  open,
  retailoring,
  retailorError,
  tonePreset,
  customTone,
  onPickPreset,
  onCustomToneChange,
  onClose,
  onSubmit,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "rgba(15, 23, 42, 0.55)" }}
      onClick={() => !retailoring && onClose()}
      data-testid="retailor-modal"
    >
      <div
        className="rm-card-static p-6 md:p-8 w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
        style={{ background: "#FFF2EC" }}
      >
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            <div className="rm-tag mb-2">Re-tailor</div>
            <h2 className="font-display text-3xl uppercase leading-tight">
              Tweak the <span className="rm-text-orange">vibe.</span>
            </h2>
          </div>
          <button
            onClick={() => !retailoring && onClose()}
            className="rm-btn rm-btn-ghost text-xs px-2 py-2"
            data-testid="retailor-close-btn"
          >
            <X size={14} />
          </button>
        </div>
        <p className="text-sm mb-4" style={{ color: "#475569" }}>
          Same job, same resume, fresh take. Pick a tone preset or describe the vibe yourself.
        </p>

        <div className="space-y-2 mb-4">
          {TONE_PRESETS.map((t) => (
            <button
              key={t.label}
              onClick={() => onPickPreset(t.value)}
              className="w-full text-left p-3 rounded-lg"
              style={{
                border: "3px solid #0F1B2D",
                background: tonePreset === t.value ? "#FFC145" : "white",
              }}
              data-testid={`tone-preset-${t.label.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <div className="font-bold text-sm">{t.label}</div>
            </button>
          ))}
        </div>

        <div className="mb-4">
          <label className="rm-label block mb-2">Or describe your own tone (optional)</label>
          <textarea
            className="rm-textarea"
            style={{ minHeight: 80 }}
            value={customTone}
            onChange={(e) => onCustomToneChange(e.target.value)}
            placeholder="e.g. 'Scrappy startup hustle with a side of dry humor'"
            data-testid="retailor-custom-tone"
          />
        </div>

        {retailorError && (
          <div
            className="p-3 mb-4 rounded-md font-mono-rm text-sm"
            style={{ background: "#FEF2F2", border: "3px solid #EF4444", color: "#991B1B" }}
            data-testid="retailor-error"
          >
            {retailorError}
          </div>
        )}

        <button
          onClick={onSubmit}
          disabled={retailoring}
          className="rm-btn rm-btn-primary w-full"
          data-testid="retailor-submit-btn"
        >
          <RefreshCw size={16} />
          {retailoring ? "Resmo is re-tailoring..." : "Re-tailor with this vibe"}
        </button>
        {retailoring ? (
          <div className="mt-3">
            <ProgressMeter expectedSeconds={30} label="Re-tailoring" testid="retailor-progress-meter" />
          </div>
        ) : (
          <div
            className="font-mono-rm text-xs mt-3 text-center"
            style={{ color: "#475569" }}
          >
            creates a new version in your history
          </div>
        )}
      </div>
    </div>
  );
}
